import * as React from 'react'

function humanFileSize(size) {
	if (size < 1024) return size + ' B'
	let i = Math.floor(Math.log(size) / Math.log(1024))
	let num = (size / Math.pow(1024, i))
	let round = Math.round(num)
	num = round < 10 ? num.toFixed(2) : round < 100 ? num.toFixed(1) : round
	return `${num}${'KMGTPEZY'[i-1]}B`
}

export const Download = ({ file, label, size, extension }) => {


	return (
		<div className="download">
			<a href={file} className="action-save">{label} ({extension.toUpperCase()} - {humanFileSize(size )})</a>
		</div>
	)
}
